import mainLogo from '../../images/Open/open_logo_reduced_black_2.png';
import squareLogo from '../../images/Open/open_logo_reduced_black_square.png';
import bannerLogoWhite from '../../images/Open/open_logo_reduced_white_2.png';
import banner01 from '../../images/Open/open_banner_01_bg_07.jpg';
import banner02 from '../../images/Open/open_banner_01_bg_06.jpg';
import banner03 from '../../images/Open/open_banner_01_bg_01.jpg';
import banner04 from '../../images/Open/open_banner_01_bg_about_01.jpg';
import car123 from '../../images/Open/123_creta.jpg';
import box123 from '../../images/Open/123_open.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Open',
    defaultStoreLink: 'pecasgrupoopen.com.br',
    defaultContactEmail: 'ecommerce@pecasgrupoopen.com.br',
    whatsappNumber: '45 99985 5617',
    CNPJname: 'Open Veiculos LTDA',
    CNPJ: '04.675.147/0001-32',
    CNPJaddress: 'Av. Brasil, 1339 - Cascavel, PR - 85.816-294',
    launchDate: '14/02/2025',

    multiContact: {
        'Hyundai': '45 99928 2373',
        'Mitsubishi': '45 99968 1466',
        'Renault': '45 99994 0958'
    },
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "hyundai",
        "mitsubishi",
        "renault",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Open Veículos Cascavel",
        "VETOR HYUNDAI CASCAVEL",
        "BRIZZA MITSUBISHI CASCAVEL",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais compatíveis com <span style="font-weight: bold;">seu veículo</span>, direto das concessionárias <span style="font-weight: bold;">Open</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'Em 2001, em Cascavel, um sonho ganhou vida pelas mãos do empresário Acyr Miguel Urio: o Grupo Open.',
            'Com rápida expansão, estendeu seus horizontes para Foz do Iguaçu, Toledo e Umuarama.',
            'Sua missão é clara: tornar realidade o sonho do carro novo, em parceria com as prestigiadas marcas Renault, Hyundai e Mitsubishi, além de uma ampla variedade de veículos seminovos, prontos para encantar e acompanhar novas jornadas.'

        ],
        link: 'https://www.grupoopenveiculos.com.br/sobre',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupoopenveiculos/',
        Facebook: 'https://www.facebook.com/openrenault/',
        LinkedIn: 'https://www.linkedin.com/company/grupoopenveiculos/',
        Youtube: 'https://www.youtube.com/@openveiculos2378',
        Twitter: '',
    },

    footerContent: [],
}